import { Draft } from '@reduxjs/toolkit';

import { IUserData } from '../../index';

function editFailure(draft: Draft<IUserData>) {
  draft.edit.config.isLoading = false;
}

export default editFailure;
